/*
 *
 * DownloadFloatingModal
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 19-Jun-2025
 */

import React from 'react'
// import PropTypes from 'prop-types'
import Toggle from 'Hoc/ToggleComponent'
import FloatingDownloadTile from 'Components/FloatingDownloadTile'
import './DownloadFloatingModal.scss'

const DownloadFloatingModal = () => (
  <Toggle>
    <div className='downloadFloatingModal'>
      <div className='downloadFloatingContainer'>
        <FloatingDownloadTile />
      </div>
    </div>
  </Toggle>
)

DownloadFloatingModal.propTypes = {
  // Add here some propTypes
  // and set a minimal description i.e.
  /** Description of prop "baz". */
}

DownloadFloatingModal.defaultProps = {
  // Add here some default propTypes values
}

export default DownloadFloatingModal
